/* global NDEFReader */
import nfc from '../assets/images/nfc-tag.png';
import React, { useEffect, useRef, useState } from 'react';
import { Textarea } from '@mantine/core';
import Button from '../components/Button';
import '../styles/pages/nfc.css';
import {apiRequest} from "../utils/api";
import {useNavigate} from "react-router-dom";
import { Html5Qrcode, Html5QrcodeScannerState } from "html5-qrcode";

const Nfc = () => {
    const html5QrCodeRef = useRef(null); // 💡 QR 인스턴스 저장용
    const [tagnum, setTagnum] = useState('');
    const [storeInfo, setStoreInfo] = useState({
        NAME: '',
        ADDR: '',
        NOTICE: ''
    });
    const [qrScanning, setQrScanning] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        readNFC(); // 페이지 진입 시 바로 실행
    }, []);

    useEffect(() => {
        // 위치 정보 요청 (페이지 진입 시)
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    const address = await getAddressFromCoords(latitude, longitude);
                    setStoreInfo((prev) => ({
                        ...prev,
                        ADDR: address,
                    }));
                },
                (error) => {
                    console.warn('초기 위치 정보를 가져오지 못했습니다:', error.message);
                },
                { enableHighAccuracy: true, timeout: 10000 }
            );
        }
    }, []);


    useEffect(() => {
        const tagnum = sessionStorage.getItem('tagnum');
        if (tagnum) {
            setTagnum(tagnum); // input 자동 반영
            fetchStoreWithTag(tagnum);
        }
    }, []);

    useEffect(() => {
        if (!qrScanning) return;

        const qrRegionId = "qr-reader";
        const html5QrCode = new Html5Qrcode(qrRegionId);
        html5QrCodeRef.current = html5QrCode; // 저장해둠

        html5QrCode.start(
            { facingMode: "environment" },
            { fps: 10, qrbox: { width: 250, height: 250 } },
            async (decodedText) => {
                console.log("QR Code decoded:", decodedText);

                try {
                    const url = new URL(decodedText);
                    const tag = url.searchParams.get("tagnum");

                    if (tag) {
                        setTagnum(tag);
                        await fetchStoreWithTag(tag);

                        // 💡 실행 중일 때만 stop
                        if (html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
                            await html5QrCode.stop();
                            console.log("QR 스캐너 종료 완료");
                        }

                        setQrScanning(false);
                    } else {
                        alert("QR 코드에 tagnum 정보가 없습니다.");
                    }
                } catch (e) {
                    alert("올바른 QR 코드 URL이 아닙니다.");
                    console.error("QR decode error:", e);
                }
            },
            (error) => {
                console.log("QR scan error:", error);
            }
        ).catch((err) => {
            console.error("QR 스캔 실패:", err);
            alert("카메라 접근에 실패했습니다.");
            setQrScanning(false);
        });

        // 💡 cleanup에서 안전하게 stop
        return () => {
            if (html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
                html5QrCode.stop().catch((err) => console.warn("stop 실패", err));
            }
        };
    }, [qrScanning]);


    const startQrScanner = () => {
        setQrScanning(true); // → useEffect에서 start() 하도록
    };

    const readNFC = async () => {
        try {
            if ('NDEFReader' in window) {
                const ndef = new NDEFReader();
                await ndef.scan();
                alert('NFC 태그를 스캔하세요.');

                // ndef.onreading = async (event) => {
                //     const serial = event.serialNumber;
                //     if (serial) {
                //         setTagnum(serial);
                //         fetchStoreWithTag(serial);
                //         alert(`태그 인식 완료: ${serial}`);
                //
                //         // ➕ 위치 정보 추가
                //         if ('geolocation' in navigator) {
                //             navigator.geolocation.getCurrentPosition(
                //                 (position) => {
                //                     const { latitude, longitude } = position.coords;
                //                     setStoreInfo((prev) => ({
                //                         ...prev,
                //                         ADDR: `현위치: (${latitude.toFixed(5)}, ${longitude.toFixed(5)})`,
                //                     }));
                //                 },
                //                 (error) => {
                //                     console.warn('위치 정보를 가져오지 못했습니다:', error.message);
                //                 },
                //                 { enableHighAccuracy: true, timeout: 10000 }
                //             );
                //         } else {
                //             console.warn('이 브라우저는 위치 정보를 지원하지 않습니다.');
                //         }
                //
                //     } else {
                //         alert('태그 번호를 읽을 수 없습니다.');
                //     }
                // };

                ndef.onreading = async (event) => {
                    const serial = event.serialNumber;
                    if (serial) {
                        setTagnum(serial);
                        fetchStoreWithTag(serial);
                        alert(`태그 인식 완료: ${serial}`);

                        // ➕ 좌표 → 주소
                        if ('geolocation' in navigator) {
                            navigator.geolocation.getCurrentPosition(
                                async (position) => {
                                    const { latitude, longitude } = position.coords;
                                    const address = await getAddressFromCoords(latitude, longitude);
                                    setStoreInfo((prev) => ({
                                        ...prev,
                                        ADDR: address,
                                    }));
                                },
                                (error) => {
                                    console.warn('위치 정보를 가져오지 못했습니다:', error.message);
                                },
                                { enableHighAccuracy: true, timeout: 10000 }
                            );
                        }
                    } else {
                        alert('태그 번호를 읽을 수 없습니다.');
                    }
                };

            }
        } catch (error) {
            alert('NFC 인식 중 오류 발생');
            console.error('NFC 읽기 오류:', error);
        }
    };

    const getAddressFromCoords = async (lat, lon) => {
        try {
            const res = await fetch(
                `https://dapi.kakao.com/v2/local/geo/coord2address.json?x=${lon}&y=${lat}`,
                {
                    headers: {
                        Authorization: 'KakaoAK 1a1e478cf616be9003bf4566f70ab6e3',
                    },
                }
            );
            const data = await res.json();
            return data.documents?.[0]?.address?.address_name || `(${lat}, ${lon})`;
        } catch (e) {
            console.error('역지오코딩 실패:', e);
            return `(${lat}, ${lon})`;
        }
    };

    const fetchStoreWithTag = async (tag) => {
        try {
            const data = await apiRequest('/getNfcInfo', 'POST', { TAGNUM: tag });
            if (data?.success && data.data) {
                const { NAME, ADDR, DETAIL_ADDR, NOTICE } = data.data;
                setStoreInfo((prev) => ({
                    ...prev,
                    NAME,
                    NOTICE
                }));
            } else {
                alert('해당 태그 정보가 없습니다.');
            }
        } catch (e) {
            alert('정보를 불러오는데 실패했습니다.');
            alert(`에러: ${e.message || JSON.stringify(e)}`);
        }
    };

    const handleNext = () => {
        navigate('/checklist', {
            state: {
                tagnum,
                storeInfo: {
                    NAME: storeInfo.NAME,
                    ADDR: storeInfo.ADDR,
                    NOTICE: storeInfo.NOTICE
                }
            }
        });
    };

    return (
        <div className='mobile-container'>
            <div className='margin-top-section'/>
            {qrScanning && (
                <div id="qr-reader" style={{ width: '300px', margin: '0 auto', paddingTop: '20px' }}></div>
            )}
            <p className='large-center-text gmarket-font'>QR로고에 기기를 태그해주세요</p>
            <div className='image-wrapper'>
                <img src={nfc} alt='nfc tag' className='tag-image'/>
            </div>
            {!tagnum && (
                <div style={{ margin: '20px 0', textAlign: 'center' }}>
                    <Button className='next-button gmarket-font' onClick={startQrScanner}>QR 코드로 태그 인식하기</Button>
                </div>
            )}

            <div className='input-wrapper gmarket-font'>
                <p>태그NO</p>
                <input className='gray-input' id="tagnum" value={tagnum} readOnly/>
            </div>
            <div className='input-wrapper gmarket-font'>
                <p>사업장명</p>
                <input className='gray-input' id="NAME" value={storeInfo.NAME} readOnly/>
            </div>
            <div className='input-wrapper gmarket-font'>
                <p>위치장소</p>
                <input className='gray-input' id="ADDR" value={storeInfo.ADDR} readOnly/>
            </div>
            <div className='title-text gmarket-font'>
                <p>공지사항</p>
                <Textarea
                    value={storeInfo.NOTICE}
                    styles={{
                        input: {
                            borderRadius: '10px',
                            background: '#F9F9F9',
                            border: 'none',
                            fontSize: '15px',
                            height: '120px',
                        }
                    }}
                    readOnly
                />
            </div>
            <Button className='next-button gmarket-font' onClick={handleNext}>다음</Button>

        </div>
    );
};

export default Nfc;
